import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

/**
 * @typedef MenuOptions
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, close: string }} [overlay]
 */

const MainMenu = {
    selector: '#header .main-nav',
    navButton: '#header .nav-button',
    overlay: {
        element: '#nav-overlay',
        close: '#nav-close',
    },
};

function moveMainNav() {
    const overlay = document.getElementById('nav-content');
    const overlayFooter = document.getElementById('nav-footer');
    const header = document.querySelector('#header .header_inside');
    const contactBar = document.querySelector('#contact-bar .contact-line');
    const navButton = document.querySelector(MainMenu.navButton);

    const mainNav = document.getElementById('main-nav');
    const changeLanguage = document.querySelector('.mod_changelanguage');

    if (getComputedStyle(navButton).display !== 'none') {
        if (mainNav.closest('#nav-content')) {
            return;
        }

        overlay.append(mainNav);
        overlayFooter.prepend(changeLanguage);
    } else {
        if (mainNav.closest('.header_inside')) {
            return;
        }

        header.append(mainNav);
        contactBar.append(changeLanguage);
    }
}

function transferClickOnDuplicatedNavButton() {
    const navButton = document.querySelector(MainMenu.navButton);
    const duplicatedNavButton = document.querySelector('#contact-bar .nav-button');

    if (navButton && duplicatedNavButton) {
        duplicatedNavButton.addEventListener('click', () => {
            navButton.click();
        });
    }
}

onDomReady(() => {
    new DropdownMenu(MainMenu);
    moveMainNav();
    transferClickOnDuplicatedNavButton();
});

window.addEventListener('resize', () => {
    moveMainNav();
});
